// extracted by mini-css-extract-plugin
export default {"value":"DashboardContent_value__d-6Pq","footer":"DashboardContent_footer__oc1lz"};